import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import { fShortenNumber } from 'src/utils/format-number';
import { useTranslate } from 'src/locales';
import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export function AccountStatistics(t0) {
  const $ = _c(25);
  let other;
  let sx;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      totalSales: t1,
      totalRating: t2,
      totalFollowers: t3,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    other = $[1];
    sx = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const totalSales = t1 === undefined ? 0 : t1;
  const totalRating = t2 === undefined ? 0 : t2;
  const totalFollowers = t3 === undefined ? 0 : t3;
  const {
    t
  } = useTranslate();
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      mt: 1,
      gap: 2,
      width: 1,
      display: "flex",
      typography: "caption",
      color: "text.disabled"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== sx) {
    t5 = Array.isArray(sx) ? sx : [sx];
    $[7] = sx;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = [t4, ...t5];
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = `${fShortenNumber(totalFollowers)} ${t(totalFollowers === 1 ? "Follower" : "Followers")}`;
  let t8;
  if ($[11] !== t7) {
    t8 = <div>{t7}</div>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = `${fShortenNumber(totalSales)} ${t(totalSales === 1 ? "Sale" : "Sales")}`;
  let t10;
  if ($[13] !== t9) {
    t10 = <div>{t9}</div>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      gap: 0.5,
      display: "flex"
    };
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Iconify icon="fluent-color:star-24" sx={{
      width: {
        xs: 16,
        md: 13
      },
      height: {
        xs: 17,
        md: 16
      }
    }} />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== totalRating) {
    t13 = <Box sx={t11}>{t12}{totalRating}</Box>;
    $[17] = totalRating;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== other || $[20] !== t10 || $[21] !== t13 || $[22] !== t6 || $[23] !== t8) {
    t14 = <Box sx={t6} {...other}>{t8}{t10}{t13}</Box>;
    $[19] = other;
    $[20] = t10;
    $[21] = t13;
    $[22] = t6;
    $[23] = t8;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
}